import type { IntlShape } from 'react-intl';
import advancedMapLayers from '../UpsellFeatureList/advancedMapLayers';
import customRoutes from '../UpsellFeatureList/customRoutes';
import routeAssistant from '../UpsellFeatureList/routeAssistant';
import unlimitedMapDownloads from '../UpsellFeatureList/unlimitedMapDownloads';

const peakFeatures = (intl: IntlShape) => [routeAssistant(intl), advancedMapLayers(intl), customRoutes(intl), unlimitedMapDownloads(intl)];

export default peakFeatures;
